// src/services/cloneManager.js - VERSION CORRIGÉE FINALE

const STORAGE_KEY = 'active_clone';

class CloneManager {
  constructor() {
    // Ne plus stocker this.clone, on lit toujours depuis localStorage
  }

  // 🔥 TOUJOURS LIRE DEPUIS LOCALSTORAGE
  loadClone() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (error) {
      console.error('❌ Erreur chargement clone:', error);
    }
    return null;
  }

  saveClone(cloneData) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(cloneData));
      return true;
    } catch (error) {
      console.error('❌ Erreur sauvegarde clone:', error);
      return false;
    }
  }

  setClone(cloneInfo) {
    const {
      clone_id,
      clone_name,
      api_url,
      token,
      inspecteur,
      logo_url,
      company_name
    } = cloneInfo;

    const cloneData = {
      clone_id,
      clone_name,
      api_url,
      token,
      inspecteur,
      logo_url: logo_url || null,
      company_name: company_name || clone_name,
      authenticated_at: new Date().toISOString()
    };

    this.saveClone(cloneData);
    
    console.log('✅ Clone configuré:', clone_name);
    console.log('✅ API URL:', api_url);
    console.log('✅ Token:', token.substring(0, 15) + '...');
    
    return cloneData;
  }

  // 🔥 TOUJOURS LIRE EN TEMPS RÉEL
  getClone() {
    return this.loadClone();
  }

  getApiUrl() {
    const clone = this.loadClone();
    return clone?.api_url || null;
  }

  getToken() {
    const clone = this.loadClone();
    return clone?.token || null;
  }

  getInspecteur() {
    const clone = this.loadClone();
    return clone?.inspecteur || null;
  }

  getCloneName() {
    const clone = this.loadClone();
    return clone?.clone_name || 'Clone';
  }

  getLogoUrl() {
    const clone = this.loadClone();
    return clone?.logo_url || null;
  }

  getCompanyName() {
    const clone = this.loadClone();
    return clone?.company_name || clone?.clone_name || 'Clone';
  }

  isAuthenticated() {
    const clone = this.loadClone();
    return !!(clone && clone.token);
  }

  updateToken(newToken) {
    const clone = this.loadClone();
    if (clone) {
      clone.token = newToken;
      this.saveClone(clone);
      console.log('✅ Token mis à jour');
      return true;
    }
    return false;
  }

  logout() {
    localStorage.removeItem(STORAGE_KEY);
    console.log('✅ Déconnexion effectuée - clone supprimé');
  }

  reset() {
    this.logout();
  }
}

const cloneManager = new CloneManager();
export default cloneManager;